module.exports = __webpack_public_path__ + "img/send-screeing-btn.c3215c91.svg";